/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/sv_SE';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Öppna den nätta versionen av HTML-redigeraren"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Tillgänglighetskontroll"
  },
  "action_to_take_b626a99a": {
    "message": "Åtgärd att vidta:"
  },
  "add_8523c19b": {
    "message": "Lägg till"
  },
  "add_a_caption_2a915239": {
    "message": "Lägg till bildtext"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Lägg till alternativtext för bilden"
  },
  "add_another_f4e50d57": {
    "message": "Lägg till en till"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Lägg till CC/undertext"
  },
  "add_image_60b2de07": {
    "message": "Lägg till bild"
  },
  "add_one_9e34a6f8": {
    "message": "Lägg till en!"
  },
  "additional_considerations_f3801683": {
    "message": "Ytterliggare hänsynstaganden"
  },
  "address_applied_64269b0b": {
    "message": "Adress tillämpad"
  },
  "address_removed_fcb496e0": {
    "message": "Adress borttagen"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Intilliggande länkar med samma webbadress ska vara en enda länk."
  },
  "ai_response_9624e8e8": {
    "message": "AI-svar:"
  },
  "ai_tools_fda01177": {
    "message": "AI-verktyg"
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Justera"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Justering och listor"
  },
  "all_4321c3a1": {
    "message": "Alla"
  },
  "all_apps_a50dea49": {
    "message": "Alla appar"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alfabetisk"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Alternativ attributtext får inte innehålla mer än 120 tecken."
  },
  "alt_text_611fb322": {
    "message": "Alternativ text"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (samprod)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Ett fel inträffade vid inläsning av filen"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Ett fel uppstod vid försök att göra en nätverksförfrågan"
  },
  "an_error_occurred_processing_your_request_a3a38d84": {
    "message": "Ett fel uppstod när din begäran behandlades."
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Ett fel uppstod när dina mediefiler laddades upp."
  },
  "and_7fcc2911": {
    "message": "Och"
  },
  "angle_c5b4ec50": {
    "message": "Vinkel"
  },
  "announcement_fb4cb645": {
    "message": "Anslag"
  },
  "announcement_list_da155734": {
    "message": "Anslagslista"
  },
  "announcements_a4b8ed4a": {
    "message": "Anslag"
  },
  "apply_781a2546": {
    "message": "Tillämpa"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Tillämpa ändringar på alla instanser för den här ikonen för ikonverktyget i kursen"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Närmar sig gränsen"
  },
  "approximately_e7965800": {
    "message": "Ungefär"
  },
  "apps_54d24a47": {
    "message": "Appar"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Vill du verkligen annullera? Ändringar du gjort kan inte sparas."
  },
  "arrows_464a3e54": {
    "message": "Pilar"
  },
  "art_icon_8e1daad": {
    "message": "Konstikon"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Bildförhållande kommer att behållas"
  },
  "assignment_976578a8": {
    "message": "Uppgift"
  },
  "assignments_1e02582c": {
    "message": "Uppgifter"
  },
  "asterisk_82255584": {
    "message": "Asterisk"
  },
  "attributes_963ba262": {
    "message": "Attribut"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Ljud- och videoinspelning stöds inte. Använd en annan webbläsare."
  },
  "audio_options_feb58e2c": {
    "message": "Ljudalternativ"
  },
  "audio_options_tray_33a90711": {
    "message": "Fack för ljudalternativ"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Ljudspelare för { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Automatiskt sparat innehåll finns. Vill du läsa in det automatiskt sparade innehållet istället?"
  },
  "available_folders_694d0436": {
    "message": "Tillgängliga mappar"
  },
  "background_1bc88842": {
    "message": "Bakgrund"
  },
  "backslash_b2d5442d": {
    "message": "Omvänt snedstreck"
  },
  "bar_ec63ed6": {
    "message": "Fält"
  },
  "basic_554cdc0a": {
    "message": "Grundläggande"
  },
  "because_501841b": {
    "message": "Eftersom"
  },
  "below_81d4dceb": {
    "message": "Nedan"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Stor cirkel"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Binomialkoefficient"
  },
  "black_4cb01371": {
    "message": "Svart"
  },
  "blue_daf8fea9": {
    "message": "Blå"
  },
  "bold_applied_42d547b7": {
    "message": "Fet stil tillämpad"
  },
  "bold_removed_da474a5c": {
    "message": "Fet stil borttagen"
  },
  "border_5b08b06d": {
    "message": "Gräns"
  },
  "bottom_15a2a9be": {
    "message": "Längst ned"
  },
  "bottom_third_5f5fec1d": {
    "message": "Tredje nerifrån"
  },
  "bowtie_5f9629e4": {
    "message": "Rosett"
  },
  "brick_f2656265": {
    "message": "Byggsten"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Avbryt"
  },
  "cap_product_3a5265a6": {
    "message": "Takprodukt"
  },
  "center_align_e68d9997": {
    "message": "Centrera"
  },
  "centered_dot_64d5e378": {
    "message": "Centrerad punkt"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Centrerade horisontella punkter"
  },
  "change_alt_text_92654906": {
    "message": "Ändra alternativtext"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Ändra rubriktagg till stycket"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Ändra bara nivån för den här rubriken"
  },
  "change_text_color_1aecb912": {
    "message": "Ändra textfärg"
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "Ändringar du gjort kan inte sparas."
  },
  "characters_9d897d1c": {
    "message": "Tecken"
  },
  "characters_no_spaces_485e5367": {
    "message": "Tecken (inga blanksteg)"
  },
  "check_accessibility_3c78211c": {
    "message": "Kontrollera tillgänglighet"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Kontrollerar tillgänglighetsproblem"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Välj undertextfil"
  },
  "choose_usage_rights_33683854": {
    "message": "Välj användningsrättigheter ..."
  },
  "circle_484abe63": {
    "message": "Cirkel"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "cirkelmarkera oordnad lista"
  },
  "clear_2084585f": {
    "message": "Rensa"
  },
  "clear_image_3213fe62": {
    "message": "Rensa bild"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Klicka eller håll Skift nedtryck och klicka för att öppna HTML-redigeraren."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Klicka för att bädda in { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Klicka för att dölja förhandsgranskning"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Klicka för att infoga en länk i redigeraren."
  },
  "click_to_show_preview_faa27051": {
    "message": "Klicka för att visa förhandsgranskning"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Stäng en meny eller dialogruta Tar dig också tillbaka till redigerarområdet"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Stäng tillgänglighetskontrollen"
  },
  "close_d634289d": {
    "message": "Stäng"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "Undertextfilen får inte vara större än { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Undertexter"
  },
  "clubs_suit_c1ffedff": {
    "message": "Klöver (kortlek)"
  },
  "collab_575ac7bc": {
    "message": "Samarbete"
  },
  "collaborations_5c56c15f": {
    "message": "Samarbeten"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Minimera för att dölja { types }"
  },
  "color_a363e1b0": {
    "message": "Färg"
  },
  "color_contrast_4c418add": {
    "message": "Färgkontrast"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Färgkontrastförhållande"
  },
  "color_picker_6b359edf": {
    "message": "Färgväljaren"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Färgväljaren ({ colorName } valda)"
  },
  "color_popup_af39810f": {
    "message": "Färg-popup"
  },
  "column_e1ae5c64": {
    "message": "Kolumn"
  },
  "column_group_1c062368": {
    "message": "Kolumngrupp"
  },
  "complex_numbers_a543d004": {
    "message": "Komplexa nummer"
  },
  "compose_44c904f4": {
    "message": "Skriv"
  },
  "computer_1d7dfa6f": {
    "message": "Dator"
  },
  "congruent_5a244acd": {
    "message": "Kongruent"
  },
  "contains_311f37b7": {
    "message": "Innehåller"
  },
  "content_1440204b": {
    "message": "Innehåll"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "Innehåll i redigeraren kommer att ändras. Tryck på Avbryt för att behålla det ursprungliga innehållet."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Innehåll laddas fortfarande upp, om du fortsätter kommer det inte att bäddas in korrekt."
  },
  "content_subtype_5ce35e88": {
    "message": "Underordnad innehållstyp"
  },
  "content_type_2cf90d95": {
    "message": "Innehållstyp"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Fortsätt till ditt YouTube-innehåll"
  },
  "coproduct_e7838082": {
    "message": "Samproduktion"
  },
  "copy_9748f9f": {
    "message": "Kopiera"
  },
  "copyright_holder_66ee111": {
    "message": "Upphovsrättsinnehavare:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Det gick inte att infoga innehåll: \"{ itemType }\" artiklarna stöds för närvarande inte i Canvas."
  },
  "count_40eced3b": {
    "message": "Antal"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 ord}\n    one {1 ord}\n  other {# ord}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# objekt laddat}\n  other {# objekt laddade}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Kursdokument"
  },
  "course_files_62deb8f8": {
    "message": "Kursfiler"
  },
  "course_files_a31f97fc": {
    "message": "Kursfiler"
  },
  "course_images_f8511d04": {
    "message": "Kursbilder"
  },
  "course_link_b369426": {
    "message": "Kurslänk"
  },
  "course_links_b56959b9": {
    "message": "Kurslänkar"
  },
  "course_media_ec759ad": {
    "message": "Kursmedia"
  },
  "course_navigation_dd035109": {
    "message": "Kursnavigering"
  },
  "create_icon_110d6463": {
    "message": "Skapa ikon"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Skapa ikon för ikonverktyget"
  },
  "creative_commons_license_725584ae": {
    "message": "Creative Commons-licens:"
  },
  "crop_image_41bf940c": {
    "message": "Beskär bild"
  },
  "crop_image_807ebb08": {
    "message": "Beskär bilden"
  },
  "cup_product_14174434": {
    "message": "Kopprodukt"
  },
  "current_image_f16c249c": {
    "message": "Aktuell bild"
  },
  "current_link_945a47ee": {
    "message": "Aktuell länk"
  },
  "current_volume_level_c55ab825": {
    "message": "Aktuell volymnivå"
  },
  "custom_6979cd81": {
    "message": "Anpassa"
  },
  "custom_width_and_height_pixels_946eea7c": {
    "message": "Anpassad bredd och höjd (pixlar)"
  },
  "cyan_c1d5f68a": {
    "message": "Cyan"
  },
  "dagger_57e0f4e5": {
    "message": "Dolk"
  },
  "date_added_ed5ad465": {
    "message": "Tillagt datum"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Dekorativ ikon"
  },
  "decorative_image_fde98579": {
    "message": "Dekorativ bild"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Dekorativ { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Minska indrag"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Minska ytan för formaterat innehåll"
  },
  "deep_purple_bb3e2907": {
    "message": "Djup lila"
  },
  "default_9db103d": {
    "message": "Standard"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "punktmarkera oordnad lista som standard"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "numrera ordnad lista som standard"
  },
  "definite_integral_fe7ffed1": {
    "message": "Bestämd integral"
  },
  "degree_symbol_4a823d5f": {
    "message": "Gradersymbol"
  },
  "delimiters_4db4840d": {
    "message": "Avgränsare"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(beskriv ikonen)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Beskriv { TYPE })"
  },
  "describe_the_video_2fe8f46a": {
    "message": "(Beskriv videon)"
  },
  "description_436c48d7": {
    "message": "Beskrivning"
  },
  "details_98a31b68": {
    "message": "Detaljer"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Diagonala punkter"
  },
  "diamond_b8dfe7ae": {
    "message": "Diamant"
  },
  "diamonds_suit_526abaaf": {
    "message": "Ruter (kortspel)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Dimensionstyp"
  },
  "dimensions_45ddb7b7": {
    "message": "Dimensioner"
  },
  "directionality_26ae9e08": {
    "message": "Textens riktning"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Direktredigera LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "Inaktivera förhandsvisning"
  },
  "discussion_6719c51d": {
    "message": "Diskussion"
  },
  "discussions_a5f96392": {
    "message": "Diskussioner"
  },
  "discussions_index_6c36ced": {
    "message": "Diskussionsindex"
  },
  "disjoint_union_e74351a8": {
    "message": "Upplöst union"
  },
  "dislike_14befc48": {
    "message": "Ogilla"
  },
  "display_options_315aba85": {
    "message": "Visa alternativ"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Visa textlänk (öppnas i en ny flik)"
  },
  "div_applied_49ad83fc": {
    "message": "Diverse tillämpade"
  },
  "div_removed_d13f8e17": {
    "message": "Diverse borttagna"
  },
  "division_sign_72190870": {
    "message": "Divisionstecken"
  },
  "document_678cd7bf": {
    "message": "Dokument"
  },
  "documents_81393201": {
    "message": "Dokument"
  },
  "done_54e3d4b6": {
    "message": "Klar"
  },
  "double_dagger_faf78681": {
    "message": "Dubbeldolk"
  },
  "down_5831a426": {
    "message": "Ner"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Diagonal pil, nedåt och till vänster"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Diagonal pil, nedåt och till höger"
  },
  "download_filename_2baae924": {
    "message": "Ladda ner { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Nedåtpil"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Nedåtpekande triangel"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Dra en fil hit"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Dra och släpp, eller klicka för att söka i din dator"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Dra handtag. Använd upp- och nedpilarna för att ändra storlek"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Förfallodatum: Flera datum"
  },
  "due_when_7eed10c6": {
    "message": "Inlämningsdatum: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Redigera alternativ text för den här ikoninstansen"
  },
  "edit_c5fbea07": {
    "message": "Redigera"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Redigera kurslänk"
  },
  "edit_equation_f5279959": {
    "message": "Redigera ekvation"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Redigera befintlig ikon för Ikonbyggaren"
  },
  "edit_icon_2c6b0e91": {
    "message": "Redigera ikon"
  },
  "edit_link_7f53bebb": {
    "message": "Redigera länk"
  },
  "editor_status_bar_653f44ee": {
    "message": "Statusfält i redigeraren"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Element som börjar med { start }"
  },
  "embed_828fac4a": {
    "message": "Bädda in"
  },
  "embed_code_314f1bd5": {
    "message": "Inbäddad kod"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Bädda in innehåll från externt verktyg"
  },
  "embed_image_1080badc": {
    "message": "Bädda in bild"
  },
  "embed_video_a97a64af": {
    "message": "Bädda in videon"
  },
  "embedded_content_aaeb4d3d": {
    "message": "inbäddat innehåll"
  },
  "empty_set_91a92df4": {
    "message": "Tom uppsättning"
  },
  "encircled_dot_8f5e51c": {
    "message": "Inringad punkt"
  },
  "encircled_minus_72745096": {
    "message": "Inringat minus"
  },
  "encircled_plus_36d8d104": {
    "message": "Inringat plus"
  },
  "encircled_times_5700096d": {
    "message": "Inringade tider"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ingenjörsikon"
  },
  "english_icon_25bfe845": {
    "message": "Engelsk ikon"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Skriv in minst 3 tecken för att söka"
  },
  "enter_replacement_text_17631bbc": {
    "message": "ange ersättningstext"
  },
  "enter_search_text_26cb4459": {
    "message": "ange söktext"
  },
  "enter_text_8b35c65b": {
    "message": "Skriv in text"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (variant)"
  },
  "equals_sign_c51bdc58": {
    "message": "Lika med-tecken"
  },
  "equation_1c5ac93c": {
    "message": "Ekvation"
  },
  "equation_editor_39fbc3f1": {
    "message": "Ekvationsredigeraren"
  },
  "equilibrium_6ff3040b": {
    "message": "Jämvikt"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Ekvivalensklass"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Ekvivalent (identitet)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Existerar"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Avsluta helskärm"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Visa förhandsgranskning som standard"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Expandera för att visa { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Extern länk"
  },
  "external_tool_frame_70b32473": {
    "message": "Extern verktygsram"
  },
  "external_tools_6e77821": {
    "message": "Externa verktyg"
  },
  "extra_large_b6cdf1ff": {
    "message": "Extra stor"
  },
  "extra_small_9ae33252": {
    "message": "Extra liten"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Fritidsikon"
  },
  "f_function_fe422d65": {
    "message": "F (funktion)"
  },
  "fail_544e5dde": {
    "message": "MISSLYCKADES"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Det gick inte att hämta filinnehåll"
  },
  "failed_to_copy_response_d3def551": {
    "message": "Det gick inte att kopiera svaret"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Det gick inte att hämta innehåll från externt verktyg"
  },
  "file_name_8fd421ff": {
    "message": "Filnamn"
  },
  "file_preview_21667a6e": {
    "message": "Förhandsgranskning av fil"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Förhandsgranskning av fil för { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Kvoten för fillagring har överskridits"
  },
  "file_url_c12b64be": {
    "message": "Filens URL"
  },
  "filename_file_icon_602eb5de": {
    "message": "{ filename } filikon"
  },
  "filename_image_preview_6cef8f26": {
    "message": "{ filename } förhandsvisning av bild"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "{ filename } förhandsvisning av text"
  },
  "files_c300e900": {
    "message": "Filer"
  },
  "files_index_af7c662b": {
    "message": "Filindex"
  },
  "find_8d605019": {
    "message": "Sök"
  },
  "find_and_replace_6e345933": {
    "message": "Sök och ersätt"
  },
  "finish_bc343002": {
    "message": "Avsluta"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Fast rubrikhierarki"
  },
  "flat_music_76d5a5c3": {
    "message": "Platt (Musik)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Verktygsfält för alternativ till fokuselement"
  },
  "folder_tree_fbab0726": {
    "message": "Mappträd"
  },
  "for_all_b919f972": {
    "message": "För alla"
  },
  "format_4247a9c5": {
    "message": "Format"
  },
  "format_as_a_list_142210c3": {
    "message": "Formatera som lista"
  },
  "formatting_5b143aa8": {
    "message": "Formaterar"
  },
  "forward_slash_3f90f35e": {
    "message": "Snedstreck"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Hittade automatiskt sparat innehåll"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Hittade { count, plural,\n     =0 {# resultat}\n    one {# resultat}\n  other {# resultat}\n}"
  },
  "fraction_41bac7af": {
    "message": "Bråkdel"
  },
  "fullscreen_873bf53f": {
    "message": "Helskärm"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "Genererar förhandsvisning ..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "GIF-/PNG-bildformat som är större än { size } kB stöds inte."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Gå till redigerarens menyfält"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Gå till redigerarens verktygsfält"
  },
  "grades_a61eba0a": {
    "message": "Omdömen"
  },
  "graphics_text_bc9568bc": {
    "message": "Bildtext"
  },
  "greater_than_e98af662": {
    "message": "Större än"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Större än eller lika med"
  },
  "greek_65c5b3f7": {
    "message": "Grekiska"
  },
  "green_15af4778": {
    "message": "Grön"
  },
  "grey_a55dceff": {
    "message": "Grå"
  },
  "group_documents_8bfd6ae6": {
    "message": "Gruppera dokument"
  },
  "group_files_4324f3df": {
    "message": "Gruppfiler"
  },
  "group_files_82e5dcdb": {
    "message": "Gruppfiler"
  },
  "group_images_98e0ac17": {
    "message": "Gruppera bilder"
  },
  "group_isomorphism_45b1458c": {
    "message": "Gruppautomorfi"
  },
  "group_link_63e626b3": {
    "message": "Grupplänk"
  },
  "group_links_9493129e": {
    "message": "Grupplänkar"
  },
  "group_media_2f3d128a": {
    "message": "Gruppera mediefiler"
  },
  "group_navigation_99f191a": {
    "message": "Gruppnavigering"
  },
  "h_bar_bb94deae": {
    "message": "H-streck"
  },
  "hat_ea321e35": {
    "message": "Keps"
  },
  "header_column_f27433cb": {
    "message": "Rubrikkolumn"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Rubrikrad och kolumn"
  },
  "header_row_f33eb169": {
    "message": "Rubrikrad"
  },
  "heading_2_5b84eed2": {
    "message": "Rubrik 2"
  },
  "heading_3_2c83de44": {
    "message": "Rubrik 3"
  },
  "heading_4_b2e74be7": {
    "message": "Rubrik 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "{ h } tillämpades i rubriken"
  },
  "heading_h_removed_745f24a6": {
    "message": "{ h } togs bort från rubriken"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Rubriknivåer bör inte hoppas över."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Rubriker som börjar med { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Rubrikerna får inte innehålla mer än 120 tecken."
  },
  "health_icon_8d292eb5": {
    "message": "Hälsoikon"
  },
  "hearts_suit_e50e04ca": {
    "message": "Hjärter (kortspel)"
  },
  "height_69b03e15": {
    "message": "Höjd"
  },
  "hello_please_describe_the_modifications_you_would__49b19837": {
    "message": "Hej! Beskriv de ändringar du vill göra i din komposition."
  },
  "hello_please_describe_the_modifications_you_would__600dbbf0": {
    "message": "Hej! Beskriv de ändringar du vill göra i ditt urval."
  },
  "hexagon_d8468e0d": {
    "message": "Hexagon"
  },
  "hide_description_bfb5502e": {
    "message": "Dölj beskrivning"
  },
  "hide_title_description_caf092ef": {
    "message": "Dölj { title } beskrivning"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Markera ett element för att aktivera verktygsfältet för elementalternativ"
  },
  "home_351838cd": {
    "message": "Hem"
  },
  "html_code_editor_fd967a44": {
    "message": "Redigerare för HTML-kod"
  },
  "html_editor_fb2ab713": {
    "message": "HTML-redigerare"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Jag har fått behörighet att använda den här filen."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Jag är upphovsrättsinnehavare"
  },
  "i_m_sorry_but_i_cannot_find_the_ai_s_answer_67569d19": {
    "message": "Jag hittar inte AI-svaret"
  },
  "icon_215a1dc6": {
    "message": "Ikon"
  },
  "icon_8168b2f8": {
    "message": "ikon"
  },
  "icon_color_b86dd6d6": {
    "message": "Ikonfärg"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Ikoner för ikonverktyget"
  },
  "icon_options_7e32746e": {
    "message": "Ikonalternativ"
  },
  "icon_options_tray_2b407977": {
    "message": "Fack för ikonalternativ"
  },
  "icon_preview_1782a1d9": {
    "message": "Förhandvisning av ikon"
  },
  "icon_shape_30b61e7": {
    "message": "Ikonform"
  },
  "icon_size_9353edea": {
    "message": "Ikonstorlek"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Om den lämnas tom, kommer länktexten att visas som kurslänkens namn"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Om användarrättigheter krävs publiceras inte filen förrän den aktiveras på sidan Filer."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Om du inte väljer användningsrättigheter nu kommer den här filen att publiceras efter att den har laddats upp."
  },
  "image_8ad06": {
    "message": "Bild"
  },
  "image_c1c98202": {
    "message": "bild"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Bildfilnamn ska inte användas som alt attribut som beskriver bildinnehållet."
  },
  "image_options_5412d02c": {
    "message": "Bildalternativ"
  },
  "image_options_tray_90a46006": {
    "message": "Alternativfält för bilder"
  },
  "image_to_crop_3a34487d": {
    "message": "Bild till beskärning"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Bild med filnamn { file }"
  },
  "images_7ce26570": {
    "message": "Bilder"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Bilder ska innehålla ett alt attribut som beskriver bildinnehållet."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Imaginärdel (av komplexa nummer)"
  },
  "in_element_of_19ca2f33": {
    "message": "I (element av)"
  },
  "increase_indent_6af90f7c": {
    "message": "Öka indrag"
  },
  "increase_rich_content_area_340b775": {
    "message": "Öka ytan för formaterat innehåll"
  },
  "indefinite_integral_6623307e": {
    "message": "Obestämd integral"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } av { max }"
  },
  "indigo_2035fc55": {
    "message": "Indigo"
  },
  "inference_fed5c960": {
    "message": "Slutsats"
  },
  "infinity_7a10f206": {
    "message": "Oändlighet"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Inmatningsfält för alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Inmatningsfält för blått"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Inmatningsfält för grönt"
  },
  "input_field_for_red_86a84615": {
    "message": "Inmatningsfält för rött"
  },
  "insert_593145ef": {
    "message": "Infoga"
  },
  "insert_link_6dc23cae": {
    "message": "Infoga länk"
  },
  "insert_math_equation_57c6e767": {
    "message": "Infoga en matematisk ekvation"
  },
  "integers_336344e1": {
    "message": "Heltal"
  },
  "intersection_cd4590e4": {
    "message": "Genomskärning"
  },
  "invalid_description_991e23bb": {
    "message": "Ogiltig beskrivning"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Ogiltig inmatning."
  },
  "invalid_file_c11ba11": {
    "message": "Ogiltig fil"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Ogiltig filtyp"
  },
  "invalid_url_cbde79f": {
    "message": "Ogiltig URL"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Problem { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Kursiv stil tillämpad"
  },
  "italic_removed_17cbab6f": {
    "message": "Kursiv stil borttagen"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (variant)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Kortkommandon"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Tangentbord navigerar till länkar via Tab-tangenten. Två intilliggande länkar som leder till samma destination kan vara förvirrande för användare av tangentbord."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Språkvetenskapsikon"
  },
  "languages_icon_9d20539": {
    "message": "Språkikon"
  },
  "large_9c5e80e7": {
    "message": "Stor"
  },
  "large_text_e7ba08cd": {
    "message": "Stor text"
  },
  "learn_ad3b3505": {
    "message": "Lär dig"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Läs mer om intilliggande länkar"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Läs mer om färgkontrast"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Läs mer om att ordna sidrubriker"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Läs mer om korrekt struktur för sidrubrik"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Läs mer om tabellrubriker"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Läs mer om att använda alternativtext för bilder"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Läs mer om att använda rubriker med tabeller"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Läs mer om att använda filnamn som alternativtext"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Läs mer om att använda listor"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Läs mer om att använda omfångsattribut med tabeller"
  },
  "leave_as_is_4facfe55": {
    "message": "Lämna som det är"
  },
  "left_3ea9d375": {
    "message": "Vänster"
  },
  "left_align_43d95491": {
    "message": "Vänsterjustera"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Vänster hakparentes"
  },
  "left_arrow_4fde1a64": {
    "message": "Vänster pil"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Vänsterpil med krok"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Vänster övre avgränsare"
  },
  "left_curly_brace_1726fb4": {
    "message": "Vänster klammerparentes"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Harpunpil, nedåt till vänster"
  },
  "left_floor_29ac2274": {
    "message": "Vänster nedre avgränsare"
  },
  "left_to_right_e9b4fd06": {
    "message": "Vänster-till-höger"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Harpunpil, uppåt till vänster"
  },
  "leftward_arrow_1e4765de": {
    "message": "Vänsterpekande pil"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Vänsterpekande triangel"
  },
  "less_than_a26c0641": {
    "message": "Mindre än"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Mindre än eller lika med"
  },
  "library_icon_ae1e54cf": {
    "message": "Biblioteksikon"
  },
  "light_blue_5374f600": {
    "message": "Ljusblå"
  },
  "link_7262adec": {
    "message": "Länk"
  },
  "link_options_a16b758b": {
    "message": "Länkalternativ"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "länktyp { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Länk med text som börjar med { start }"
  },
  "links_14b70841": {
    "message": "Länkar"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Länkar till en extern sida."
  },
  "lists_cd1336fc": {
    "message": "Listor"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Listor ska formateras som listor."
  },
  "load_more_35d33c7": {
    "message": "Läs in mer"
  },
  "loading_25990131": {
    "message": "Läser in ..."
  },
  "loading_bde52856": {
    "message": "Läser in"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "det gick inte att läsa in undertexter."
  },
  "loading_external_tool_d839042c": {
    "message": "Laddar externt verktyg"
  },
  "loading_failed_b3524381": {
    "message": "Det gick inte att läsa in ..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Det gick inte att läsa in."
  },
  "loading_folders_d8b5869e": {
    "message": "Läser in mappar"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Läser in platshållare för { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Läser in, vänta"
  },
  "loading_preview_9f077aa1": {
    "message": "Förhandsgranskning av inläsning"
  },
  "locked_762f138b": {
    "message": "Låst"
  },
  "logical_equivalence_76fca396": {
    "message": "Logisk ekvivalens"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Logisk ekvivalens (kort)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Logisk ekvivalens (kort och tjock)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Logisk ekvivalens (tjock)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Låga horisontella punkter"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Mappar till"
  },
  "math_icon_ad4e9d03": {
    "message": "Matteikon"
  },
  "media_af190855": {
    "message": "Media"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "Mediefilen behandlas. Försök igen senare."
  },
  "media_title_2112243b": {
    "message": "Medietitel"
  },
  "medium_5a8e9ead": {
    "message": "Medium"
  },
  "merge_links_2478df96": {
    "message": "Sammanfoga länkar"
  },
  "mic_a7f3d311": {
    "message": "Mikrofon"
  },
  "microphone_disabled_15c83130": {
    "message": "Mikrofonen är inaktiverad"
  },
  "middle_27dc1d5": {
    "message": "Mitten"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimera förhandsvisning av fil"
  },
  "minimize_video_20aa554b": {
    "message": "Minimera video"
  },
  "minus_fd961e2e": {
    "message": "Minus"
  },
  "minus_plus_3461f637": {
    "message": "Minus/plus"
  },
  "misc_3b692ea7": {
    "message": "Diverse"
  },
  "miscellaneous_e9818229": {
    "message": "Blandat"
  },
  "modify_6b0b13e3": {
    "message": "Ändra"
  },
  "module_90d9fd32": {
    "message": "Modul"
  },
  "modules_c4325335": {
    "message": "Moduler"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Flyttar bild till beskärning { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Flerfärgsbild"
  },
  "multiplication_sign_15f95c22": {
    "message": "Multipliceringstecken"
  },
  "music_icon_4db5c972": {
    "message": "Musikikon"
  },
  "my_files_2f621040": {
    "message": "Mina filer"
  },
  "n_th_root_9991a6e4": {
    "message": "N:te rot"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Namn"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Naturlig (musik)"
  },
  "natural_numbers_3da07060": {
    "message": "Naturliga tal"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navigera via menyn eller verktygsfältet"
  },
  "navigation_ee9af92d": {
    "message": "Navigering"
  },
  "nested_greater_than_d852e60d": {
    "message": "Kapslade större än"
  },
  "nested_less_than_27d17e58": {
    "message": "Kapslad mindre än"
  },
  "new_quiz_34aacba6": {
    "message": "Nytt quiz"
  },
  "next_40e12421": {
    "message": "Nästa"
  },
  "next_findtext_9d69f0fe": {
    "message": "Nästa { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Inga tillgänglighetsproblem upptäcktes."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Inga meddelanden har skapats än."
  },
  "no_announcements_found_20185afc": {
    "message": "Inga meddelande hittades."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Inga uppgifter har skapats än."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Inga uppgifter hittades."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Inga ändringar att spara."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Inga diskussioner har skapats än."
  },
  "no_discussions_found_9284063b": {
    "message": "Inga diskussioner hittades."
  },
  "no_e16d9132": {
    "message": "Nej"
  },
  "no_file_chosen_9a880793": {
    "message": "Ingen fil har valts"
  },
  "no_headers_9bc7dc7f": {
    "message": "Inga rubriker"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Inga moduler har skapats än."
  },
  "no_modules_found_2df43a40": {
    "message": "Inga moduler hittades."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Inga sidor har skapats än."
  },
  "no_pages_found_6799350": {
    "message": "Inga sidor hittades."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Förhandsvisning är inte tillgänglig för den här filen."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Inga quiz har skapats än."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Inga quiz hittades."
  },
  "no_results_940393cf": {
    "message": "Inga resultat."
  },
  "no_results_found_58717065": {
    "message": "Inga resultat hittades"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Inga resultat hittades för { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Ingen video"
  },
  "none_3b5e34d2": {
    "message": "Ingen"
  },
  "none_selected_b93d56d2": {
    "message": "Inga valda"
  },
  "normal_text_7b03da48": {
    "message": "Normal text"
  },
  "not_equal_6e2980e6": {
    "message": "Är inte lika med"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Inte i (inte ett element av)"
  },
  "not_negation_1418ebb8": {
    "message": "Inte (negation)"
  },
  "not_subset_dc2b5e84": {
    "message": "Inte delmängd"
  },
  "not_subset_strict_23d282bf": {
    "message": "Inte delmängd (strikt)"
  },
  "not_superset_5556b913": {
    "message": "Inte superset"
  },
  "not_superset_strict_24e06f36": {
    "message": "Inte superset (strikt)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Oktogon"
  },
  "olive_6a3e4d6b": {
    "message": "Oliv"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "En av följande stilar måste läggas till för att spara en ikon: Ikonfärg, konturstorlek, ikontext eller bild"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "En eller fler filer klistrades inte in. Försök ladda upp eller dra och släpp filer."
  },
  "open_circle_e9bd069": {
    "message": "Öppen cirkel"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Öppna dialogrutan för detta kortkommando"
  },
  "open_title_application_fd624fc5": {
    "message": "Öppna programmet { title }"
  },
  "operators_a2ef9a93": {
    "message": "Operatörer"
  },
  "options_3ab0ea65": {
    "message": "Alternativ"
  },
  "or_9b70ccaa": {
    "message": "Eller"
  },
  "orange_81386a62": {
    "message": "Orange"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Ordnade och oordnade listor"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Andra genvägar till redigeraren kan hittas på"
  },
  "outline_color_3ef2cea7": {
    "message": "Konturfärg"
  },
  "outline_size_a6059a21": {
    "message": "Konturstorlek"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } är inte ett giltigt protokoll."
  },
  "page_50c4823d": {
    "message": "Sida"
  },
  "pages_e5414c2c": {
    "message": "Sidor"
  },
  "paragraph_5e5ad8eb": {
    "message": "Paragraf"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Stycke tillämpat"
  },
  "paragraph_removed_d09320e": {
    "message": "Stycke borttaget"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Stycke som börjar med { start }"
  },
  "parallel_d55d6e38": {
    "message": "Parallel"
  },
  "partial_derivative_4a9159df": {
    "message": "Partiell (derivat)"
  },
  "pass_1c19a2b3": {
    "message": "GODKÄND"
  },
  "paste_5963d1c1": {
    "message": "Klistra in"
  },
  "pause_12af3bb4": {
    "message": "Pausa"
  },
  "pentagon_17d82ea3": {
    "message": "Pentagon"
  },
  "people_b4ebb13c": {
    "message": "Personer"
  },
  "percentage_34ab7c2c": {
    "message": "Procent"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "Procenttalet måste vara ett tal"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "Procenttalet måste vara minst { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Underhållningsikon"
  },
  "perpendicular_7c48ede4": {
    "message": "Lodrät"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (variant)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Ikon för idrott och hälsa"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (variant)"
  },
  "pick_a_color_557abfb0": {
    "message": "Välj en färg"
  },
  "pink_68ad45cb": {
    "message": "Rosa"
  },
  "pixels_52ece7d1": {
    "message": "Pixlar"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Antalet pixlar måste vara minst { width } x { height } pixlar"
  },
  "play_1a47eaa7": {
    "message": "Spela upp"
  },
  "play_media_comment_35257210": {
    "message": "Spela upp mediekommentar."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Spela upp mediekommentar av { name } från { createdAt }."
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Ge Canvas åtkomst till din mikrofon och webbkamera."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Välj en fil"
  },
  "please_decribe_what_you_would_like_to_compose_27a51be5": {
    "message": "Beskriv vad du vill komponera."
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Ange ett filnamn"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Ange ett giltig URL från en plattform som stöds."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Välj en fil som stöds."
  },
  "plus_d43cd4ec": {
    "message": "Plus"
  },
  "plus_minus_f8be2e83": {
    "message": "Plus/minus"
  },
  "posted_when_a578f5ab": {
    "message": "Publicerad: { when }"
  },
  "power_set_4f26f316": {
    "message": "Potensmängd"
  },
  "precedes_196b9aef": {
    "message": "Föregår"
  },
  "precedes_equal_20701e84": {
    "message": "Föregår lika med"
  },
  "preformatted_d0670862": {
    "message": "Förformaterad"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Föregående"
  },
  "preview_53003fd2": {
    "message": "Förhandsvisa"
  },
  "preview_a3f8f854": {
    "message": "FÖRHANDSGRANSKA"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Förhandsgranskning i överlägg"
  },
  "preview_inline_9787330": {
    "message": "Inbäddad förhandsgranskning"
  },
  "previous_bd2ac015": {
    "message": "Föregående"
  },
  "previous_findtext_8dfbfd30": {
    "message": "Föregående { findText }"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Tidigare valda färger"
  },
  "prime_917ea60e": {
    "message": "Prim"
  },
  "prime_numbers_13464f61": {
    "message": "Primtal"
  },
  "product_39cf144f": {
    "message": "Produkt"
  },
  "proportional_f02800cc": {
    "message": "Proportionell"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protokollet måste vara ftp, http, https, mailto, skype, tel eller så kan det utelämnas"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "publicerad"
  },
  "published_when_302d8e23": {
    "message": "Publicerad: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Pumpa"
  },
  "purple_7678a9fc": {
    "message": "Lila"
  },
  "quaternions_877024e0": {
    "message": "Kvarternion"
  },
  "quiz_e0dcce8f": {
    "message": "Quiz"
  },
  "quizzes_7e598f57": {
    "message": "Quiz"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Rationellt tal"
  },
  "real_numbers_7c99df94": {
    "message": "Reella tal"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Imaginärdel (av komplexa nummer)"
  },
  "record_7c9448b": {
    "message": "Spela in"
  },
  "record_upload_media_5fdce166": {
    "message": "Spela in/ladda upp media"
  },
  "recording_98da6bda": {
    "message": "Inspelning"
  },
  "red_8258edf3": {
    "message": "Röd"
  },
  "relationships_6602af70": {
    "message": "Relationer"
  },
  "religion_icon_246e0be1": {
    "message": "Religiös ikon"
  },
  "remove_f47dc62a": {
    "message": "Ta bort"
  },
  "remove_filename_3ea029f6": {
    "message": "Ta bort { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Ta bort rubrikstil"
  },
  "remove_link_d1f2f4d0": {
    "message": "Ta bort länk"
  },
  "remove_studio_media_f913e502": {
    "message": "Ta bort Studio-mediefiler"
  },
  "replace_all_d3d68b3": {
    "message": "Ersätt alla"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Ersätt alla { findText } med { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Ersätt"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Ersätt { findText } med { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Ersätt med"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Ersatte { alertFindText } med { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Ersatte alla { alertFindText } med { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Återställ"
  },
  "resize_ec83d538": {
    "message": "Ändra storlek"
  },
  "response_copied_to_clipboard_130d66cd": {
    "message": "Svar kopierades till Urklipp"
  },
  "restore_auto_save_deccd84b": {
    "message": "Vill du återställa funktionen Spara automatiskt?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Resultat { index } av { max }."
  },
  "retry_ebd5f8ba": {
    "message": "Försök igen"
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Vändkors"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (variant)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Redigerare för formaterat innehåll"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "RTF-område. Tryck på { OSKey }+F8 för genvägar till innehållsredigeraren."
  },
  "right_71ffdc4d": {
    "message": "Höger"
  },
  "right_align_39e7a32a": {
    "message": "Högerjustera"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Höger hakparentes"
  },
  "right_arrow_35e0eddf": {
    "message": "Högerpil"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Högerpil med krok"
  },
  "right_ceiling_839dc744": {
    "message": "Höger övre avgränsare"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Höger klammerparentes"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Harpunpil, nedåt till höger"
  },
  "right_floor_5392d5cf": {
    "message": "Höger nedre avgränsare"
  },
  "right_to_left_9cfb092a": {
    "message": "Höger-till-vänster"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Harpunpil, uppåt till höger"
  },
  "rightward_arrow_32932107": {
    "message": "Högerpil"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Högerpekande triangel"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Rotera bild -90 grader"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Rotera bild 90 grader"
  },
  "rotation_9699c538": {
    "message": "Rotation"
  },
  "row_fc0944a7": {
    "message": "Rad"
  },
  "row_group_979f5528": {
    "message": "Radgrupp"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Tyvärr fungerar inte tangentbordet i den nätta HTML-redigeraren. Öppna den råa HTML-redigeraren här."
  },
  "save_11a80ec3": {
    "message": "Spara"
  },
  "save_copy_ca63944e": {
    "message": "Spara kopia"
  },
  "save_media_cb9e786e": {
    "message": "Spara mediefiler"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Sparade ikoner för ikonverktyget"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Skärmläsare kan inte avgöra vad som visas i en bild utan alternativtext, och filnamn är ofta meningslösa strängar av siffror och bokstäver som inte beskriver sammanhanget eller betydelsen."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Skärmläsare kan inte avgöra vad som visas i en bild utan alternativtext, som beskriver innehållet och innebörden av bilden. Alternativtext ska vara enkel och koncis."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Skärmläsare kan inte avgöra vad som visas i en bild utan alternativtext, som beskriver innehållet och innebörden av bilden."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Skärmläsare kan inte tolka tabeller utan rätt struktur. Tabellrubriker tillhandahåller riktning och innehållsomfattning."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Skärmläsare kan inte tolka tabeller utan rätt struktur. Tabellrubriker beskriver sammanhanget och den allmänna förståelsen av tabellen."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Skärmläsare kan inte tolka tabeller utan rätt struktur. Tabellrubriker tillhandahåller riktning och en överblick över innehållet."
  },
  "script_l_42a7b254": {
    "message": "Skript-L"
  },
  "search_280d00bd": {
    "message": "Sök"
  },
  "select_audio_source_21043cd5": {
    "message": "Välj ljudkälla"
  },
  "select_crop_shape_d441feeb": {
    "message": "Välj beskärningsform"
  },
  "select_language_7c93a900": {
    "message": "Välj språk"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Välj videokälla"
  },
  "selected_274ce24f": {
    "message": "Valda"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Markerade { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Val"
  },
  "set_header_scope_8c548f40": {
    "message": "Ange rubrikens omfattning"
  },
  "set_minus_b46e9b88": {
    "message": "Uppsättning av minus"
  },
  "set_table_header_cfab13a0": {
    "message": "Ange tabellrubrik"
  },
  "sharp_music_ab956814": {
    "message": "Korsförtecken (musik)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SKIFT + pilar"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Tryck på Skift+O för att öppna den nätta HTML-redigeraren."
  },
  "shortcut_911d6255": {
    "message": "Genväg"
  },
  "show_all_967a90f0": {
    "message": "Visa alla"
  },
  "show_audio_options_b489926b": {
    "message": "Visa ljudalternativ"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Visa bildalternativ"
  },
  "show_link_options_545338fd": {
    "message": "Visa länkalternativ"
  },
  "show_studio_media_options_a0c748c6": {
    "message": "Visa mediealternativ för Studio"
  },
  "show_video_options_6ed3721a": {
    "message": "Visa videoalternativ"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Seende användare bläddrar snabbt bland webbsidor och letar efter stora rubriker eller rubriker i fetstil. Användare av skärmläsare använder sig av rubriker för kontextuell förståelse. Rubriker ska använda rätt struktur."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Seende användare bläddrar snabbt bland webbsidor och letar efter stora rubriker eller rubriker i fetstil. Användare av skärmläsare använder sig av rubriker för kontextuell förståelse. Rubriker ska vara koncisa inom den korrekta strukturen."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (variant)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Enfärgsbild"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Enfärgad bildfärg"
  },
  "size_b30e1077": {
    "message": "Storlek"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "Storleken på undertextfilen överstiger maxstorleken på { max } kb."
  },
  "small_b070434a": {
    "message": "Liten"
  },
  "solid_circle_9f061dfc": {
    "message": "Solid cirkel"
  },
  "something_went_wrong_89195131": {
    "message": "Någonting gick fel."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Något gick fel vid försök att komma åt din webbkamera."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Något gick fel och jag vet inte vad jag ska visa dig."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Någonting gick fel. Kontrollera din anslutning, läs in sidan igen och försök igen."
  },
  "something_went_wrong_d238c551": {
    "message": "Något gick fel"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Något gick fel vid delning av skärmen."
  },
  "sort_by_e75f9e3e": {
    "message": "Sortera efter"
  },
  "spades_suit_b37020c2": {
    "message": "Spader (kortlek)"
  },
  "square_511eb3b3": {
    "message": "Kvadrat"
  },
  "square_cap_9ec88646": {
    "message": "Kvadratiskt snitt"
  },
  "square_cup_b0665113": {
    "message": "Kvadratisk union"
  },
  "square_root_e8bcbc60": {
    "message": "Kvadratrot"
  },
  "square_root_symbol_d0898a53": {
    "message": "Kvadratrotsymbol"
  },
  "square_subset_17be67cb": {
    "message": "Kvadratisk delmängd"
  },
  "square_subset_strict_7044e84f": {
    "message": "Kvadratisk delmängd (strikt)"
  },
  "square_superset_3be8dae1": {
    "message": "Kvadratisk delmängd"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Kvadratisk super set (strikt)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "fyrkantsmarkera oordnad lista"
  },
  "star_8d156e09": {
    "message": "Stjärna"
  },
  "start_over_f7552aa9": {
    "message": "Börja om"
  },
  "start_recording_9a65141a": {
    "message": "Starta inspelning"
  },
  "steel_blue_14296f08": {
    "message": "Stålblå"
  },
  "studio_media_options_ee504361": {
    "message": "Mediealternativ för Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Panel för Studio-mediealternativ"
  },
  "styles_2aa721ef": {
    "message": "Stilar"
  },
  "submit_a3cc6859": {
    "message": "Lämna in"
  },
  "submitting_b90fac62": {
    "message": "Skickar ..."
  },
  "subscript_59744f96": {
    "message": "Nedsänkt"
  },
  "subset_19c1a92f": {
    "message": "Delmängd"
  },
  "subset_strict_8d8948d6": {
    "message": "Delmängd (strikt)"
  },
  "succeeds_9cc31be9": {
    "message": "Efterräder"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Efterträder lika med"
  },
  "sum_b0842d31": {
    "message": "Summa"
  },
  "superscript_8cb349a2": {
    "message": "Upphöjd"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Upphöjd och nedsänkt text"
  },
  "superset_c4db8a7a": {
    "message": "Superset"
  },
  "superset_strict_c77dd6d2": {
    "message": "Superset (strikt)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Filtyper som stöds: SRT eller WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Växla till den nätta HTML-redigeraren"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Växla till den råa HTML-redigeraren"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Växla till HTML-redigeraren"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Växla till innehållsredigeraren"
  },
  "syllabus_f191f65b": {
    "message": "Kursöversikt"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Systemljud tillåts"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Systemljud inaktiverat"
  },
  "tab_arrows_4cf5abfc": {
    "message": "FLIK/Pilar"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Tabellrubrik som börjar med { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tabell som börjar med { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Tabellrubriker ska specificera omfattning."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Tabeller ska innehålla en bildtext som beskriver innehållet i tabellen."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Tabeller ska innehålla minst en rubrik."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Teal"
  },
  "text_7f4593da": {
    "message": "Text"
  },
  "text_background_color_16e61c3f": {
    "message": "Bakgrundsfärg för text"
  },
  "text_color_acf75eb6": {
    "message": "Textfärg"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Texten är svår att läsa utan tillräcklig kontrast mellan text och bakgrund, speciellt för de med nedsatt syn."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Text som är större än 18pt (eller fetstil 14pt) bör ha ett kontrastförhållande på minst 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Text (valfritt)"
  },
  "text_position_8df8c162": {
    "message": "Textposition"
  },
  "text_size_887c2f6": {
    "message": "Textstorlek"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Text som är mindre än 18pt (eller fet 14pt) bör ha ett kontrastförhållande på minst 4,5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "Förhandsvisningen av dokumentet bearbetas. Försök igen senare."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "Den första rubriken på en sida ska vara i H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "Höjden på ytan för formaterat innehåll har minskat."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "Höjden på ytan för formaterat innehåll har ökat."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Materialet är i den offentliga domänen"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Materialet är licensierat av Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "Undantag finns för materialet – t.ex. rättvis användning, rätt att citera, eller andra gällande copyright-lagar."
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "Tangentbordet fungerar inte i den nätta HTML-redigeraren. Tryck på Skift+O för att öppna den råa HTML-redigeraren."
  },
  "therefore_d860e024": {
    "message": "Därför"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (variant)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Tjock nedåtpil"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Tjock vänsterpil"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Tjock vänsterpekande pil"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Tjock vänsterpil"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Tjock högerpekande pil"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Tjock högerpil"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Det här dokumentet kan inte visas i Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Den här ekvationen kan inte tolkas i enkel vy."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Den här bilden är för närvarande inte tillgänglig"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Den här videon kan visa YouTube-annonser."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Din video har korrekt titel i webbläsaren, men den uppdaterades inte i databasen."
  },
  "thumbnail_e0de666f": {
    "message": "Miniatyr"
  },
  "timebar_a4d18443": {
    "message": "Tidsfält"
  },
  "title_ee03d132": {
    "message": "Titel"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "För publicering: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Att göra: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Växla { summary }-grupp"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Växla verktygstips"
  },
  "tools_2fcf772e": {
    "message": "Verktyg"
  },
  "top_66e0adb6": {
    "message": "Överst"
  },
  "tray_839df38a": {
    "message": "Fack"
  },
  "triangle_6072304e": {
    "message": "Triangel"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Vändkors (Släpper igenom)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "Skriv Control F9 för åtkomst till bildalternativ. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "Skriv Control F9 för åtkomst till länkalternativ. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "Skriv Control F9 för åtkomst till tabellalternativ. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Det gick inte att bestämma URL för resursurval"
  },
  "underline_applied_ae01ec97": {
    "message": "Understrykning tillämpad"
  },
  "underline_removed_3693e17c": {
    "message": "Understrykning borttagen"
  },
  "union_e6b57a53": {
    "message": "Union"
  },
  "unpublished_dfd8801": {
    "message": "avpublicerad"
  },
  "untitled_16aa4f2b": {
    "message": "Namnlös"
  },
  "untitled_efdc2d7d": {
    "message": "namnlös"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Diagonal pil, uppåt och till vänster"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Diagonal pil, uppåt och till höger"
  },
  "up_c553575d": {
    "message": "Upp"
  },
  "updated_link_a827e441": {
    "message": "Uppdaterad länk"
  },
  "upload_document_253f0478": {
    "message": "Ladda upp dokument"
  },
  "upload_file_fd2361b8": {
    "message": "Ladda upp fil"
  },
  "upload_image_6120b609": {
    "message": "Ladda upp bild"
  },
  "upload_media_ce31135a": {
    "message": "Ladda upp media"
  },
  "upload_record_media_e4207d72": {
    "message": "Ladda upp/spela in media"
  },
  "uploading_19e8a4e7": {
    "message": "Laddar upp"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "markera alfabetisk ordnad lista med versaler"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Versal Delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Versal Gamma"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Versal Lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Versal Omega"
  },
  "uppercase_phi_caa36724": {
    "message": "Versal Phi"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Versal Pi"
  },
  "uppercase_psi_6395acbe": {
    "message": "Versal Psi"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "markera ordnad lista med romerska siffror"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Versal Sigma"
  },
  "uppercase_theta_49afc891": {
    "message": "Versal Theta"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Versal Ypsilon"
  },
  "uppercase_xi_341e8556": {
    "message": "Versal Xi"
  },
  "upsilon_33651634": {
    "message": "Ypsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Upp- och nedåtpekande pil"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Upp- och nedåtpekande pil (tjock)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Upppil"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Uppåtpekande triangel"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Användningsrättigheter:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Användningsrättigheter (krävs)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Använd piltangenterna för att navigera bland alternativen."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Använd pilknapparna för att välja en form."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Använd pilknapparna för att välja en storlek."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Använd pilknapparna för att välja en textposition."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Använd pilknapparna för att välja en textstorlek."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Använd pilknapparna för att välja en konturstorlek."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Används av skärmläsare för att beskriva innehållet i en { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Används av skärmläsare för att beskriva en bilds innehåll"
  },
  "used_by_screen_readers_to_describe_the_video_37ebad25": {
    "message": "Används av skärmläsare för att beskriva videon"
  },
  "user_documents_c206e61f": {
    "message": "Användardokument"
  },
  "user_files_78e21703": {
    "message": "Användarfiler"
  },
  "user_images_b6490852": {
    "message": "Användarbilder"
  },
  "user_media_14fbf656": {
    "message": "Användarmedia"
  },
  "vector_notation_cf6086ab": {
    "message": "Vektor (notation)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Vertikalt fält (ange byggnotering)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Vertikala punkter"
  },
  "video_options_24ef6e5d": {
    "message": "Videoalternativ"
  },
  "video_options_tray_3b9809a5": {
    "message": "Alternativfält för videor"
  },
  "video_player_b371005": {
    "message": "Videospelare"
  },
  "video_player_for_9e7d373b": {
    "message": "Videospelare för "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Videospelare för { title }"
  },
  "video_url_889d3263": {
    "message": "Video-URL"
  },
  "view_all_e13bf0a6": {
    "message": "Visa alla"
  },
  "view_ba339f93": {
    "message": "Visa"
  },
  "view_description_30446afc": {
    "message": "Visa beskrivning"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Visa kortkommandon"
  },
  "view_title_description_67940918": {
    "message": "Visa beskrivning för { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Visa ord- och teckenräkning"
  },
  "waiting_for_response_1efd0c50": {
    "message": "Väntar på svar"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Det gick inte att identifiera en fungerande mikrofon kopplad till din enhet."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Det gick inte att identifiera en fungerande mikrofon kopplad till din enhet."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Det gick inte att identifiera en fungerande webbkamera eller mikrofon kopplad till din enhet."
  },
  "webcam_disabled_30c66986": {
    "message": "Webbkamera inaktiverad"
  },
  "webcam_fe91b20f": {
    "message": "Webbkamera"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "Webbsidor ska bara ha en enkel H1, som automatiskt används för sidans titel. Den första rubriken i ditt innehåll ska vara i H2."
  },
  "what_would_you_like_to_do_6dc0d541": {
    "message": "Vad vill du göra?"
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Om markeringar används som visuellt formaterar objekt som listor men inte visar listans relation kan användare få svårt att navigera informationen."
  },
  "white_87fa64fd": {
    "message": "Vit"
  },
  "why_523b3d8c": {
    "message": "Varför"
  },
  "width_492fec76": {
    "message": "Bredd"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Bredd och höjd måste anges med siffror"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }pixlar"
  },
  "wiki_home_9cd54d0": {
    "message": "Startsida Wiki"
  },
  "word_count_c77fe3a6": {
    "message": "Antal ord"
  },
  "words_b448b7d5": {
    "message": "Ord"
  },
  "wreath_product_200b38ef": {
    "message": "Kransprodukt"
  },
  "writing_assistant_a30ac16a": {
    "message": "Skrivassistent"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "Ja"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Du är på en färgpalett. För att navigera upp, till vänster/höger eller ned på paletten, använd knapparna W, A, S och D."
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Du är på ett färgreglage. För att navigera upp, till vänster/höger eller ned i skjutreglaget, använd knapparna A och D."
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Du är på ett alfareglage. För att navigera upp, till vänster/höger eller ned i skjutreglaget, använd knapparna A och D."
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Du har ändringar som inte har sparats i facket för ikonverktyget. Vill du fortsätta utan att spara dessa ändringar?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Du måste eventuellt justera fler rubriker för att underhålla sidhierarkin."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Du får inte ladda upp en tom fil"
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Din bild har komprimerats för ikonbyggaren. Bilder som är mindre än { size } kB komprimeras inte."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Din mikrofon är blockerad i webbläsarens inställningar."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Din webbkamera och mikrofon är blockerade i webbläsarens inställningar."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Din webbkamera är blockerad i webbläsarens inställningar."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Din webbkamera kanske redan används."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "Inbäddad Youtube-URL"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Zooma in bilden"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Zooma ut bilden"
  }
};
formatMessage.addLocale({
  sv: locale
});